// @codekit-prepend '../../parts/header-top/header-top';
// @codekit-prepend '../../parts/header-home/header-home';

jQuery(document).ready(function( $ ) {
  $('#nav-icon,#nav-icon2').click(function(){
    $('body').toggleClass('pc-frozen');
    $('header .pc-mobile-nav-wrapper').toggleClass('open');
	});

  window.pcRunningFn = false
  $('.woo-variation-raw-select:first-of-type').closest('table').find('select').on('change',function(){

    if(window.pcRunningFn){
      return;
    }

    window.pcRunningFn = true;
    var $select = $(this)
    var nextRows = $select.closest('tr').nextAll('tr');


    nextRows.each(function(key){

      $(this).find('option').prop('selected',false);
      $(this).find('li.selected').removeClass('selected').attr('aria-checked',false);
      if($select.val() && !key){
        $(this).removeClass('toggle-closed');
      } else{

        $(this).addClass('toggle-closed');
      }
      })

    window.pcRunningFn = false;
  });

    $('.woo-variation-raw-select:first-of-type').trigger('change');

   $("#yith-wapo-container").appendTo("table.variations tbody");
   $("#yith-wapo-container").wrap('<tr class="toggle-closed"></tr>');

   $('<div class="pc-price-wrapper"></div>').insertBefore($('.single_add_to_cart_button'));
   $('.woocommerce-variation').appendTo($('.pc-price-wrapper'));

});
